import {
    Flex,
    Icon,
    Icons,
    NavigationListButton,
    Text,
    ThemeColorVariable,
    ThemeIconSizeVariable,
    ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";

interface ISideNavigationMenu {
    onClick: () => void;
    areaLabel?: string;
    icon: Icons;
    text: string;
    trackingId?: string;
}

export function SideNavigationMenuButton({
    onClick,
    areaLabel,
    icon,
    text,
    trackingId,
}: ISideNavigationMenu) {
    return (
        <NavigationListButton
            onClick={onClick}
            aria-label={areaLabel}
            data-track-click={trackingId}
        >
            <Flex gap={ThemeSpaceVariable.Small} align="center">
                <Icon
                    icon={icon}
                    size={ThemeIconSizeVariable.Small}
                    color={ThemeColorVariable.OnBackground}
                />
                <Text>{text}</Text>
            </Flex>
        </NavigationListButton>
    );
}
